import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d7a6c66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "v-list-item__prepend" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Список заявлений", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "v-list-item__prepend" }
const _hoisted_6 = { class: "v-list-item__prepend" }
const _hoisted_7 = { class: "v-list-item__prepend" }
const _hoisted_8 = { class: "v-list-item__prepend" }
const _hoisted_9 = { class: "v-list-item__prepend" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarComponent = _resolveComponent("NavbarComponent")!
  const _component_Folder = _resolveComponent("Folder")!
  const _component_DropdownUp = _resolveComponent("DropdownUp")!
  const _component_DropdownIcon = _resolveComponent("DropdownIcon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_Rubbish = _resolveComponent("Rubbish")!
  const _component_Subscribers = _resolveComponent("Subscribers")!
  const _component_Document = _resolveComponent("Document")!
  const _component_ProfileSvg = _resolveComponent("ProfileSvg")!
  const _component_Statistic = _resolveComponent("Statistic")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_Statements = _resolveComponent("Statements")!
  const _component_Drafts = _resolveComponent("Drafts")!
  const _component_Signatories = _resolveComponent("Signatories")!
  const _component_NewSignatories = _resolveComponent("NewSignatories")!
  const _component_Documents = _resolveComponent("Documents")!
  const _component_NewDocuments = _resolveComponent("NewDocuments")!
  const _component_Profile = _resolveComponent("Profile")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_Statistics = _resolveComponent("Statistics")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_app = _resolveComponent("v-app")!
  const _component_ModalResolution = _resolveComponent("ModalResolution")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_main, null, {
          default: _withCtx(() => [
            _createVNode(_component_NavbarComponent, {
              client_avatar: _ctx.client.client_avatar,
              client_name: _ctx.client.client_name,
              client_docs: _ctx.client.client_docs,
              client_docs_timeout: _ctx.client.client_docs_timeout
            }, null, 8, ["client_avatar", "client_name", "client_docs", "client_docs_timeout"]),
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_v_card, { style: {"height":"3000px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_layout, { style: {"height":"3000px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_navigation_drawer, {
                        modelValue: _ctx.drawer,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.drawer) = $event)),
                        rail: _ctx.storeDM.rail,
                        permanent: "",
                        onClick: _ctx.sidebar_click,
                        style: _normalizeStyle('padding: 0px; width: '+_ctx.sidebar_width)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, {
                            density: "compact",
                            nav: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, {
                                onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.click_statements(); _ctx.openStatements(); _ctx.selectComponent('statements')})
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_2, [
                                    _createVNode(_component_Folder, {
                                      class: _normalizeClass([{ active: _ctx.componentType.value === 'statements' }, "mdi-account-group-outline mdi v-icon notranslate v-theme--light v-icon--size-default"]),
                                      "aria-hidden": "true",
                                      density: "compact"
                                    }, null, 8, ["class"]),
                                    _createElementVNode("div", {
                                      class: _normalizeClass([{ active: _ctx.componentType.value === 'statements' }, "v-list-item-title"])
                                    }, " Заявления ", 2)
                                  ]),
                                  (_ctx.statementsShow && _ctx.componentType.value === 'statements')
                                    ? (_openBlock(), _createBlock(_component_DropdownUp, { key: 0 }))
                                    : (_openBlock(), _createBlock(_component_DropdownIcon, { key: 1 }))
                                ]),
                                _: 1
                              }),
                              (_ctx.statementsShow && _ctx.componentType.value === 'statements')
                                ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.click_statements(); _ctx.selectComponent('statements')}),
                                    class: _normalizeClass(["dropdown", { dropdownActive: _ctx.componentType.value === 'statements' }])
                                  }, _hoisted_4, 2)), [
                                    [_vShow, !_ctx.storeDM.rail]
                                  ])
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_list_item, {
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectComponent('drafts')))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_5, [
                                    _createVNode(_component_Rubbish, {
                                      class: _normalizeClass([{ active: _ctx.componentType.value === 'drafts' }, "mdi-account-group-outline mdi v-icon notranslate v-theme--light v-icon--size-default"]),
                                      "aria-hidden": "true",
                                      density: "compact"
                                    }, null, 8, ["class"]),
                                    _createElementVNode("div", {
                                      class: _normalizeClass([{ active: _ctx.componentType.value === 'drafts' }, "v-list-item-title"])
                                    }, " Черновики ", 2)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item, {
                                onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.openSignatories(); _ctx.selectComponent('signatories');})
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_6, [
                                    _createVNode(_component_Subscribers, {
                                      class: _normalizeClass([{ active: _ctx.componentType.value === 'signatories' || _ctx.componentType.value == 'newSignatories' }, "mdi-account-group-outline mdi v-icon notranslate v-theme--light v-icon--size-default"]),
                                      "aria-hidden": "true",
                                      density: "compact"
                                    }, null, 8, ["class"]),
                                    _createElementVNode("div", {
                                      class: _normalizeClass([{ active: _ctx.componentType.value == 'signatories' || _ctx.componentType.value == 'newSignatories' }, "v-list-item-title"])
                                    }, "Подписанты", 2)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item, {
                                onClick: _cache[4] || (_cache[4] = ($event: any) => {
                _ctx.openDocuments();
                _ctx.selectComponent('documents');})
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_component_Document, {
                                      class: _normalizeClass([{ active: _ctx.componentType.value === 'documents' || _ctx.componentType.value == 'newDocuments' }, "mdi-account-group-outline mdi v-icon notranslate v-theme--light v-icon--size-default"]),
                                      "aria-hidden": "true",
                                      density: "compact"
                                    }, null, 8, ["class"]),
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["v-list-item-title", { active: _ctx.componentType.value == 'documents' || _ctx.componentType.value == 'newDocuments' }])
                                    }, "Доверенности", 2)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item, {
                                onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.openProfile(); _ctx.selectComponent('profile');})
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_8, [
                                    _createVNode(_component_ProfileSvg, {
                                      class: _normalizeClass([{ active: _ctx.componentType.value === 'profile' || _ctx.componentType.value === 'notification' }, "mdi-account-group-outline mdi v-icon notranslate v-theme--light v-icon--size-default"]),
                                      "aria-hidden": "true",
                                      density: "compact"
                                    }, null, 8, ["class"]),
                                    _createElementVNode("div", {
                                      class: _normalizeClass([{ active: _ctx.componentType.value === 'profile' || _ctx.componentType.value === 'notification' }, "v-list-item-title"])
                                    }, " Профиль ", 2)
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item, {
                                class: "mt-10",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => {
                _ctx.openStatistics();
                _ctx.selectComponent('statistics');})
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_9, [
                                    _createVNode(_component_Statistic, {
                                      class: _normalizeClass(["mdi-account-group-outline mdi v-icon notranslate v-theme--light v-icon--size-default", { active: _ctx.componentType.value == 'statistics' }]),
                                      "aria-hidden": "true",
                                      density: "compact"
                                    }, null, 8, ["class"]),
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["v-list-item-title", { active: _ctx.componentType.value == 'statistics' }])
                                    }, "Статистика", 2)
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (!_ctx.storeDM.rail)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                class: "closeIcon",
                                variant: "text",
                                icon: "mdi-chevron-left",
                                onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.storeDM.rail = true), ["stop"]))
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "rail", "onClick", "style"]),
                      _createVNode(_component_v_main, {
                        style: _normalizeStyle('height: 100%; padding-bottom: 20px; --v-layout-left: '+_ctx.sidebar_layout_left)
                      }, {
                        default: _withCtx(() => [
                          (_ctx.componentType.value === 'statements')
                            ? (_openBlock(), _createBlock(_component_Statements, {
                                key: 0,
                                doc_list: _ctx.doc_list,
                                ref: "ref_statements",
                                onEditProxy: _ctx.edit_proxy,
                                onEditSignatory: _ctx.edit_signatory
                              }, null, 8, ["doc_list", "onEditProxy", "onEditSignatory"]))
                            : _createCommentVNode("", true),
                          (_ctx.componentType.value === 'drafts')
                            ? (_openBlock(), _createBlock(_component_Drafts, {
                                key: 1,
                                doc_list: _ctx.doc_list,
                                onCnc: _ctx.cnc
                              }, null, 8, ["doc_list", "onCnc"]))
                            : _createCommentVNode("", true),
                          (_ctx.componentType.value === 'signatories')
                            ? (_openBlock(), _createBlock(_component_Signatories, {
                                key: 2,
                                signatory_list: _ctx.signatory_list,
                                onEditSignatory: _ctx.edit_signatory,
                                onNewSignatory: _ctx.new_signatory
                              }, null, 8, ["signatory_list", "onEditSignatory", "onNewSignatory"]))
                            : _createCommentVNode("", true),
                          (_ctx.componentType.value === 'newSignatories')
                            ? (_openBlock(), _createBlock(_component_NewSignatories, {
                                key: 3,
                                onSaveSignatory: _ctx.signatory_save,
                                onEditSignatory: _ctx.edit_signatory,
                                onEditProxy: _ctx.edit_proxy,
                                onEditDoc: _ctx.edit_doc
                              }, null, 8, ["onSaveSignatory", "onEditSignatory", "onEditProxy", "onEditDoc"]))
                            : _createCommentVNode("", true),
                          (_ctx.componentType.value === 'documents')
                            ? (_openBlock(), _createBlock(_component_Documents, {
                                key: 4,
                                onEditProxy: _ctx.edit_proxy,
                                onNewProxy: _ctx.new_proxy
                              }, null, 8, ["onEditProxy", "onNewProxy"]))
                            : _createCommentVNode("", true),
                          (_ctx.componentType.value === 'newDocuments')
                            ? (_openBlock(), _createBlock(_component_NewDocuments, {
                                key: 5,
                                proxy_id: _ctx.proxy_id,
                                onEditSignatory: _ctx.edit_signatory,
                                onEditStatements: _ctx.cnc
                              }, null, 8, ["proxy_id", "onEditSignatory", "onEditStatements"]))
                            : _createCommentVNode("", true),
                          (_ctx.componentType.value === 'profile')
                            ? (_openBlock(), _createBlock(_component_Profile, {
                                key: 6,
                                onChangeAvatar: _ctx.change_avatar,
                                onChangeName: _ctx.change_name
                              }, null, 8, ["onChangeAvatar", "onChangeName"]))
                            : _createCommentVNode("", true),
                          (_ctx.componentType.value === 'notification')
                            ? (_openBlock(), _createBlock(_component_Notification, { key: 7 }))
                            : _createCommentVNode("", true),
                          (_ctx.componentType.value === 'statistics')
                            ? (_openBlock(), _createBlock(_component_Statistics, { key: 8 }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["style"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ModalResolution, { is_open: true })
  ], 64))
}